export default __webpack_public_path__ + "static/media/loginImg.4bc0eef1.svg";